import * as angular from 'angular';
import { NfcRetailerStickersService } from '../nfc-retailer-stickers.service';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { NfcOperationsRequest, NfcOperation } from '../../core';
import * as moment from 'moment';

class NfcRetailerHistoryTab {
    public static $inject = ['$scope', '$translate', 'nfcRetailerStickersService', 'notificationService', 'retailerServiceUrl'];
    public waiting: boolean;
    public filter = {
        from: <Date>new Date(new Date().getFullYear(), 0, 1),
        to: <Date>new Date()
    };
    public items: NfcOperation[] = [];
    public total: number;
    public noHistoryItemsMessage: string = this.$translate.instant('nfc_history_tab_empty_list_message');

    public dateFromOptions = {
        formatYear: 'yyyy',
        startingDay: 0
    };

    public dateToOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: this.filter.from
    };

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService,
        private readonly retailerUrl: string
    ) {
        this.waiting = false;
    }

    $onInit() {
        this.loadData();
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            this.$scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            this.$scope.$apply();
        });
    }

    dateChange = () => {
        if (this.filter.from != null && this.filter.to != null) {
            this.loadData();
        }
    }

    dateFromChange = () => {
        if (moment(this.filter.from).isSameOrAfter(this.filter.to, 'day')) {
            this.filter.to =  moment(this.filter.to).endOf('day').toDate();
            this.filter.from =  moment(this.filter.to).startOf('day').toDate();
        }

        this.loadData();
    }

    dateToChange = () => {
        if (moment(this.filter.to).isSameOrBefore(this.filter.from, 'day')) {
            this.filter.to =  moment(this.filter.from).endOf('day').toDate();
            this.filter.from =  moment(this.filter.from).startOf('day').toDate();
        }

        this.loadData();
    }

    private loadData = () => {
        if (this.waiting) {
            return;
        }
        this.waiting = true;

        let filter: NfcOperationsRequest = {
            From: this.filter.from,
            To: this.filter.to
        };

        this.notificationService.showWaitingMessage();

        this.nfcRetailerStickersService.getOperations(filter)
            .then((response) => {
                this.total = response.Total;
                this.items = response.Items;

                angular.forEach(this.items, (historyItem) => {
                    if (historyItem.ExportResult && historyItem.ExportResult.length) {
                        angular.forEach(historyItem.ExportResult, exportResult => {
                            exportResult.Url = `${this.retailerUrl}nfcStickers/results/csv/${historyItem.ID}/${exportResult.PlaceID}`;
                        });
                    }
                });
            })
            .catch(error => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

}

angular.module('naut').component('nfcRetailerHistoryTab', {
    template: require('./nfc-retailer-history-tab.component.html'),
    controller: NfcRetailerHistoryTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/history/nfc-retailer-history-tab.component.ts